import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CampaignFormContainer } from '@/features/advertising';

export default function AdsCampaignEditPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return null;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">{t('ads.campaigns.edit')}</h1>
        <p className="text-muted-foreground">{t('ads.campaigns.editDescription')}</p>
      </div>
      <CampaignFormContainer campaignId={id} />
    </div>
  );
}
